import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';
import { betSlipErrorMapping, defaultBetSlipErrorConfig } from '@swf/sports/config/bet-slip-errors';

import { getErrorConfig } from '../utils/getErrorConfig';

const useDismissibleBetSlipError = () => {
  const errorCode = useSelector(select.betSlip.errorCode);
  const errorResponse = useSelector(select.betSlip.errorResponse);
  const siteId = useSelector(select.cms.getSiteId);
  const hasNonAutoDismissibleBetError = useSelector(select.betSlip.hasNonAutoDismissibleBetError);
  const dispatch = useDispatch<Dispatch>();
  const errorConfig =
    errorCode &&
    getErrorConfig({
      config: betSlipErrorMapping[errorCode] ?? defaultBetSlipErrorConfig,
      siteId
    });

  return {
    ...errorConfig,
    isAutoDismissible: errorConfig?.isAutoDismissible !== false && !hasNonAutoDismissibleBetError,
    dismissError: dispatch.betSlip.errorDismissed,
    errorResponse
  };
};

export default useDismissibleBetSlipError;
